<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="100px" size="mini" :inline="false">
            <div class="card margin_b15 flex grxx">
                <div class="cardTitle">{{'['+$t('personInformation_personal_information')+']'}}</div>
                <div class="cardInfo">
                    <div class="flex">
                        <el-form-item class="form-title" prop="i_national" :label="$t('personInformation_country')" style="width: 50%" :required='formData.i_rytype!==10'>
                            <el-select  v-if="canEdit" style="width: 100%" v-model="formData.i_national" @change="gjChange" filterable  size="mini" >
                                <el-option v-for="item in gjList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                            </el-select>
                            <div class="mrA" v-else>{{formData.vc_country}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_nation" :label="$t('personInformation_ethnic_group')" style="width: 50%" :required='formData.i_rytype!==10&&formData.i_national==5175'>
                            <el-input v-if="canEdit" v-model="formData.vc_nation" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_nation}}</div>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <el-form-item class="form-title" prop="vc_native_place" :label="$t('personInformation_ancestral_native_place')" style="width: 50%" :required='formData.i_rytype!==10&&formData.i_national==5175'>
                            <el-input v-if="canEdit" v-model="formData.vc_native_place" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_native_place}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_used_name" :label="$t('personInformation_former_name')" style="width: 50%">
                            <el-input v-if="canEdit" v-model="formData.vc_used_name" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_used_name}}</div>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <el-form-item class="form-title" prop="vc_name" :label="$t('personInformation_name')" style="width: 50%" required>
                            <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_name}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_sex" :label="$t('personInformation_gender')" style="width: 50%" :required='formData.i_rytype!==10'>
                            <el-radio-group v-model="formData.vc_sex" @change="forceUpdate" v-if="canEdit">
                                <el-radio  :label="$t('personInformation_male')">{{$t('personInformation_male')}}</el-radio>
                                <el-radio  :label="$t('personInformation_female')">{{$t('personInformation_female')}}</el-radio>
                            </el-radio-group>
                            <div class="mrA" v-else>{{formData.vc_sex}}</div>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <el-form-item class="form-title" prop="dt_birthday" :label="$t('personInformation_date_of_birth')" style="width: 50%" >
                            <el-date-picker v-if="canEdit" style="width: 100%" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    size="mini" v-model="formData.dt_birthday" type="date" >
                            </el-date-picker>
                            <div class="mrA" v-else>{{formData.dt_birthday}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="dt_seniority" :label="$t('personInformation_working_start_date')" style="width: 50%">
                            <el-date-picker v-if="canEdit" style="width: 100%" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                            size="mini" v-model="formData.dt_seniority" type="date" >
                            </el-date-picker>
                            <div class="mrA" v-else>{{formData.dt_seniority}}</div>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <el-form-item class="form-title" prop="vc_degree" :label="$t('personInformation_education')" style="width: 50%" >
                            <el-input v-if="canEdit" v-model="formData.vc_degree" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_degree}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_political" :label="$t('personInformation_political_status')" style="width: 50%">
                            <el-input v-if="canEdit" v-model="formData.vc_political" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_political}}</div>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <el-form-item class="form-title" prop="vc_zjnum" :label="$t('personInformation_id_number')" style="width: 50%" >
                            <el-input v-if="canEdit" v-model="formData.vc_zjnum" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_zjnum}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_docnum" :label="$t('personInformation_file_no')" style="width: 50%">
                            <el-input v-if="canEdit" v-model="formData.vc_docnum" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_docnum}}</div>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <el-form-item class="form-title" prop="i_ismarried" :label="$t('personInformation_marital_status')" style="width: 50%" >
                            <el-radio-group v-model="formData.i_ismarried" @change="forceUpdate" v-if="canEdit">
                                <el-radio  :label="1">{{$t('personInformation_yes')}}</el-radio>
                                <el-radio  :label="0">{{$t('personInformation_no')}}</el-radio>
                            </el-radio-group>
                            <div class="mrA" v-else>{{formData.i_order==1?$t('personInformation_yes'):$t('personInformation_no')}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_hobby" :label="$t('personInformation_hobbies')" style="width: 50%">
                            <el-input v-if="canEdit" v-model="formData.vc_hobby" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_hobby}}</div>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <el-form-item class="form-title" prop="vc_hk_property" :label="$t('personInformation_household_registration_type')" style="width: 50%" >
                            <el-input v-if="canEdit" v-model="formData.vc_hk_property" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_hk_property}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_hk_place" :label="$t('personInformation_household_registration_address')" style="width: 50%">
                            <el-input v-if="canEdit" v-model="formData.vc_hk_place" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_hk_place}}</div>
                        </el-form-item>
                    </div>
                </div>
                 <div class="cardImg margin_l8">
                    <div style="height:328px ;width: calc(100% - 5px); position: relative;border: 1px solid #DCDFE6;" >
                        <input type="file" name="files" value="" id="uploadfile1" v-if="canEdit"
                               class="upload-input uploadfile1" @change="uploadFile($event)">
                        <div class="uploadDiv" v-if="formData.vc_filepath==''"><i class="el-icon-plus" style="font-size: 30px;"></i></div>
                        <img :src="file_root+formData.vc_filepath" style="height:100% ;width: 100%" v-if="formData.vc_filepath">
                  </div>
                </div>
            </div>
            <div class="flex margin_b8">
                <div class="card gzxx">
                    <div class="cardTitle">{{'['+$t('personInformation_job_information')+']'}}</div>
                    <div class="cardInfo">
                        <el-form-item class="form-title" prop="i_rytype" :label="$t('personInformation_personnel_category')" style="width: 100%" required>
                            <el-select  v-if="canEdit&&data.type=='add'" style="width: 100%" v-model="formData.i_rytype" @change="rytypeChange" filterable :remote="true" :remote-method="typesearch" size="mini" >
                                <el-option v-for="item in i_rytypeList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                            </el-select>
                            <div class="mrA" v-else>{{formData.vc_rytype}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="dt_entry" :label="$t('personInformation_entry_date')" style="width: 100%" :required='formData.i_rytype!==10'>
                            <el-date-picker v-if="canEdit&&data.type=='add'" style="width: 100%" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                            size="mini" v-model="formData.dt_entry" type="date" >
                            </el-date-picker>
                            <div class="mrA" v-else>{{formData.dt_entry}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="i_gsid" :label="$t('personInformation_entry_company')" style="width: 100%" :required='formData.i_rytype!==10'>
                            <div class="mrA">{{formData.vc_gsname}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="i_dept" :label="$t('personInformation_entry_department')" style="width: 100%" :required='formData.i_rytype!==10'>
                            <div class="mrA" >{{formData.vc_dept}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="i_headship" :label="$t('personInformation_job_rank')" style="width: 100%">
                            <el-select @change="headshipChange" v-if="canEdit&&data.type=='add'" style="width: 100%" v-model="formData.i_headship" filterable :remote="true" :remote-method="headshipsearch" size="mini" >
                                <el-option v-for="item in i_headshipList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                            </el-select>
                            <div class="mrA" v-else>{{formData.vc_headship}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="i_order" :label="$t('personInformation_sort')" style="width: 100%">
                            <el-input v-if="canEdit" v-model="formData.i_order" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.i_order}}</div>
                        </el-form-item>
                        <div class="flex">
                            <el-form-item class="form-title" prop="i_isuser" :label="$t('personInformation_oa_login_permission')" style="width: 150px" required>
                             <el-switch v-model="formData.i_isuser" :active-value="1" :inactive-value="0"  @input="i_isuserChange" :disabled="!canEdit||!OAcanEdit"></el-switch>

                            </el-form-item>
                            <el-form-item class="form-title" prop="i_login_type"  v-if="formData.i_isuser==1" :label="$t('personInformation_login_method')" style="flex: 1" :required="formData.i_isuser==1&&formData.i_rytype!==10">
                                <el-radio-group v-model="formData.i_login_type " @change="forceUpdate" v-if="canEdit">
                                    <el-radio  :label="1">{{$t('personInformation_email')}}</el-radio>
                                    <el-radio  :label="0">{{$t('personInformation_office_mobile')}}</el-radio>
                                </el-radio-group>
                                <div class="mrA" v-else>{{formData.i_login_type ==1?$t('personInformation_email'):$t('personInformation_office_mobile')}}</div>
                            </el-form-item>
                        </div>
                        <el-form-item v-if="formData.i_isuser==1" class="form-title" prop="vc_login" :label="$t('personInformation_oa_login_name')" style="width: 100%" required>
                            <template v-if="canEdit&&OAcanEdit">
                                <el-input v-model="formData.vc_login" size="mini" :placeholder="$t('personInformation_please_input')" style="width:calc(100% - 14px)" @input="vc_loginChange"></el-input>
                                <i class="el-icon-check" style="color: green" v-if="vc_loginCheck"></i>
                                <i class="el-icon-close" style="color: red" v-if="!vc_loginCheck"></i>
                            </template>
                            <div class="mrA" v-else>{{formData.vc_login}}</div>

                        </el-form-item>
                    </div>

                </div>
                <div class="card margin_l8 lxfs">
                    <div class="cardTitle">{{'['+$t('personInformation_contact_information')+']'}}</div>
                    <div class="cardInfo">
                        <div class="flex">
                            <el-form-item class="form-title" prop="vc_self_phone" :label="$t('personInformation_personal_mobile')" style="width: 50%" :required='formData.i_rytype!==10'>
                                <el-input v-if="canEdit" v-model="formData.vc_self_phone" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                                <div class="mrA" v-else>{{formData.vc_self_phone}}</div>
                            </el-form-item>
                            <el-form-item class="form-title" prop="vc_self_tel" :label="$t('personInformation_home_phone')" style="width: 50%">
                                <el-input v-if="canEdit" v-model="formData.vc_self_tel" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                                <div class="mrA" v-else>{{formData.vc_self_tel}}</div>
                            </el-form-item>
                        </div>
                        <div class="flex">
                            <el-form-item class="form-title" prop="vc_qq" :label="$t('personInformation_qq')" style="width: 50%" >
                                <el-input v-if="canEdit" v-model="formData.vc_qq" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                                <div class="mrA" v-else>{{formData.vc_qq}}</div>
                            </el-form-item>
                            <el-form-item class="form-title" prop="vc_self_email" :label="$t('personInformation_email')" style="width: 50%" :required="formData.i_isuser==1&&formData.i_rytype!==10&&formData.i_login_type==1">
                                <el-input v-if="canEdit" v-model="formData.vc_self_email" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                                <div class="mrA" v-else>{{formData.vc_self_email}}</div>
                            </el-form-item>
                        </div>
                        <div class="flex">
                            <el-form-item class="form-title" prop="vc_group_phone" :label="$t('personInformation_office_mobile')" style="width: 50%" :required="formData.i_isuser==1&&formData.i_rytype!==10&&formData.i_login_type==0">
                                <el-input v-if="canEdit" v-model="formData.vc_group_phone" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                                <div class="mrA" v-else>{{formData.vc_group_phone}}</div>
                            </el-form-item>
                            <el-form-item class="form-title" prop="vc_group_tel" :label="$t('personInformation_office_landline')" style="width: 50%">
                                <el-input v-if="canEdit" v-model="formData.vc_group_tel" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                                <div class="mrA" v-else>{{formData.vc_group_tel}}</div>
                            </el-form-item>
                        </div>
                        <el-form-item class="form-title" prop="vc_address" :label="$t('personInformation_home_address')" style="width: 100%">
                            <el-input v-if="canEdit" v-model="formData.vc_address" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_address}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_address_now" :label="$t('personInformation_current_address')" style="width: 100%">
                            <el-input v-if="canEdit" v-model="formData.vc_address_now" size="mini" :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.vc_address_now}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="i_djid" :label="$t('personInformation_attendance_no')" style="width: 100%" >
                            <el-input v-if="canEdit" v-model="formData.i_djid" size="mini" clearable :placeholder="$t('personInformation_please_input')"></el-input>
                            <div class="mrA" v-else>{{formData.i_djid}}</div>
                        </el-form-item>
                        <el-form-item class="form-title" prop="vc_djmark" :label="$t('personInformation_attendance_shift')" style="width: 100%" >
                            <el-select  v-if="canEdit" v-model="formData.vc_djmark" @change="vc_djmarkChange" clearable size="mini" style="width: 50%;margin-right: 8px" >
                                <el-option v-for="item in vc_djmarkList" :key="item.vc_djmark" :label="item.vc_tcname" :value="item.vc_djmark"></el-option>
                            </el-select>
                            <div class="dib " v-else>{{formData.vc_bz}}</div>
                            <el-select  v-if="canEdit" v-model="formData.i_classid" filterable clearable :remote="true" :remote-method="classidsearch" @change="classChange" size="mini"  style="width:calc(50% - 8px)" >
                                <el-option v-for="item in i_classidList" :key="item.i_id" :label="item.vc_classname" :value="item.i_id"></el-option>
                            </el-select>
                            <div class="dib margin_l8"  v-else>{{formData.vc_classname}}</div>
                        </el-form-item>
                        <div class="flex">
                            <el-form-item :label="$t('personInformation_yonyou_code')" class="form-title"  prop="vc_code_yongyou" style="width: 100%">
                                <span style="margin-right: 3px">{{formData.vc_code_yongyou}}</span>
                                <el-button v-if="formData.i_id!=0&&canEdit" type="text" @click="tosync($t('personInformation_yonyou'))">{{$t('personInformation_synchronize')}}</el-button>
                            </el-form-item>
                            <el-form-item :label="$t('personInformation_nanbei_code')" class="form-title"  prop="vc_code_nanbei" style="width: 100%">
                                <span style="margin-right: 3px">{{formData.vc_code_nanbei}}</span>
                                <el-button v-if="formData.i_id!=0&&canEdit" type="text" @click="tosync($t('personInformation_nanbei'))">{{$t('personInformation_synchronize')}}</el-button>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
<!--            <el-form-item class="form-title" prop="vc_lruname" label="录入人" style="width: 50%" >-->
<!--                <div class="mrA" >{{formData.vc_lruname}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="dt_createtime" label="录入时间" style="width: 50%" >-->
<!--                <div class="mrA" >{{formData.dt_createtime}}</div>-->
<!--            </el-form-item>-->
        </el-form>
        <div  class="center">
            <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
            <!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
            <!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
            <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">{{$t('button_edit')}}</el-button>
            <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion,file_root} from "@/utils/baseUrl";

    export default {
        name: "BasicInformation",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            var validateEmail = (rule, value, callback) => {
                if (value === ''&&this.formData.i_national!=5175&&this.formData.i_isuser==1) {
                    callback(new Error(this.$t('personInformation_please_enter_email')));
                } else {
                    callback();
                }
            };
            var validatePhone = (rule, value, callback) => {
                if (value === ''&&this.formData.i_isuser==1&&this.formData.i_national==5175) {
                    callback(new Error(this.$t('personInformation_please_enter_office_mobile')));
                } else {
                    callback();
                }
            };
            var validateLogin = (rule, value, callback) => {
                if (value === ''&&this.formData.i_isuser==1) {
                    callback(new Error(this.$t('personInformation_please_enter_oa_login_name')));
                } else {
                    callback();
                }
            };
            var validateNational = (rule, value, callback) => {
                if (value === ''&&this.formData.i_rytype!==10) {
                    callback(new Error(this.$t('personInformation_country_cannot_be_empty')));
                } else {
                    callback();
                }
            };
            var validateNation = (rule, value, callback) => {
                if (value === ''&&this.formData.i_rytype!==10) {
                    callback(new Error(this.$t('personInformation_ethnic_group_cannot_be_empty')));
                } else {
                    callback();
                }
            };
            var validateNativePlace = (rule, value, callback) => {
                if (value === ''&&this.formData.i_rytype!==10) {
                    callback(new Error(this.$t('personInformation_ancestral_native_place_cannot_be_empty')));
                } else {
                    callback();
                }
            };
            var validateEntry = (rule, value, callback) => {
                if (value === ''&&this.formData.i_rytype!==10) {
                    callback(new Error(this.$t('personInformation_entry_date_cannot_be_empty')));
                } else {
                    callback();
                }
            };
            var validateSelfPhone = (rule, value, callback) => {
                if (value === ''&&this.formData.i_rytype!==10) {
                    callback(new Error(this.$t('personInformation_personal_mobile_cannot_be_empty')));
                } else {
                    callback();
                }
            };
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    vc_filepath:'',
                    vc_sex:this.$t('personInformation_male'),
                    i_ismarried:0,
                    i_isuser:0,
                    i_classid:null,
                    i_gsid:'',
                    i_dept:'',
                    i_djid:'',
                    vc_djmark:'',
                    // i_classid:'',
                    vc_code_yongyou:'',
                    vc_code_nanbei:'',
                    i_id:0,
                    i_login_type:0,
                },

                rules:{
                    vc_name:[{required: true,message:this.$t('personInformation_name_cannot_be_empty')}],
                    i_national:[{validator:validateNational,message:this.$t('personInformation_country_cannot_be_empty')}],
                    vc_nation:[{validator:validateNation,message:this.$t('personInformation_ethnic_group_cannot_be_empty')}],
                    vc_native_place:[{validator:validateNativePlace,message:this.$t('personInformation_ancestral_native_place_cannot_be_empty')}],
                    i_rytype:[{required: true,message:this.$t('personInformation_personnel_category_cannot_be_empty')}],
                    dt_entry:[{validator:validateEntry,message:this.$t('personInformation_entry_date_cannot_be_empty')}],
                    vc_self_phone:[{validator:validateSelfPhone,message:this.$t('personInformation_personal_mobile_cannot_be_empty')}],
                    // i_djid:[{required: true,message:'考勤登记号不能为空'}],
                    // vc_djmark:[{required: true,message:'考勤班种不能为空'}],
                    i_isuser:[{required: true,message:this.$t('personInformation_oa_login_permission_cannot_be_empty')}],
                    vc_sex:[{required: true,message:this.$t('personInformation_gender_cannot_be_empty')}],
                    vc_self_email:[{validator:validateEmail,trigger: 'blur'}],
                    vc_group_phone:[{validator:validatePhone,trigger: 'blur'}],
                    vc_login:[{validator:validateLogin,trigger: 'blur'}],
                },
                canEdit:false,
                OAcanEdit:false,
                disabled:false,
                gjList:[],
                i_rytypeList:[],
                i_headshipList:[],
                vc_djmarkList:[],
                i_classidList:[],
                headship_search:'',
                classid_search:'',
                type_search:'',
                vc_loginCheck:null,
                file_root:'',
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.file_root = file_root;
            this.$nextTick(() => {
                this.onResize();
            });
            this.now=this.$DateTime.now();
            //console.log(this.data,'this.data')
            if(this.data.type=='add'){
                this.canEdit=true;
                this.OAcanEdit=true;
                this.getAreaTree();
                this.getUserTypeList();
                this.getUserHeadShip();
                this.getKqList();
                this.formData.i_gsid=this.data.val.i_gsid;
                this.formData.vc_gsname=this.data.val.vc_gsname;
                this.formData.i_dept=this.data.val.i_id;
                this.formData.vc_dept=this.data.val.vc_name;
                this.formData.vc_filepath='';
                this.formData.vc_sex='男';
                this.formData.i_ismarried=0;
                this.formData.i_isuser=0;
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            }else{
                this.getUserDetail()
            }
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            tosync(text){
                this.$confirm(this.$t('personInformation_synchronize_to')+text+this.$t('personInformation_system'),this.$t('personInformation_prompt'),{
                    confirmButtonText:this.$t('button_sure'),
                    cancelButtonText:this.$t('button_cancel'),
                    type:"warning"
                }).then(()=>{
                    console.log(this.formData,"this.formData")
                    this.updatesystem(text);
                }).catch(()=>{
                    this.$message.info(this.$t('personInformation_cancel_operation'))
                })
            },
            async updatesystem(text){
                let param={};
                let res={};
                if(text==this.$t('personInformation_yonyou')){
                    param={
                        i_id:this.formData.i_id,
                        i_gsid:this.formData.i_gsid,
                        i_dept:this.formData.i_dept,
                        vc_name:this.formData.vc_name,
                    };
                    res=await API.saveUser(param);
                }
                if(text==this.$t('personInformation_nanbei')){
                    param={
                        i_id:this.formData.i_id,
                        i_gsid:this.formData.i_gsid,
                        i_dept:this.formData.i_dept,
                    };
                    res=await API.saveSNUser(param);
                }
                if ( res.code == 1 ){
                    this.getUserDetail()
                    this.$message.success(res.message);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            gjChange(){
                this.formData.vc_country=this.gjList.find(i=>this.formData.i_national==i.i_id).vc_name
            },
            rytypeChange(){
                this.formData.vc_rytype=this.i_rytypeList.find(i=>this.formData.i_rytype==i.i_id).vc_name
                this.formData.i_state=this.i_rytypeList.find(i=>this.formData.i_rytype==i.i_id).i_state
            },
            classChange(val){
                this.$set(this.formData,'i_classid',val)
                this.formData.vc_classname=this.i_classidList.find(i=>this.formData.i_classid==i.i_id).vc_classname
            },
            headshipChange(val){
                this.$set(this.formData,'i_headship',val)
                this.formData.vc_headship=this.i_headshipList.find(i=>this.formData.i_headship==i.i_id).vc_name
            },
            save(formName){
                if(this.formData.i_isuser==1&&!this.vc_loginCheck) {
                    this.$message(this.$t('personInformation_oa_login_name_is_unavailable'))
                }else{
                    this.$refs[formName].validate((valid)=>{
                        if(valid){
                            if(this.data.type=='add'){
                                this.addUser()
                            }else{
                                this.editUser()
                            }
                        }else{
                            return false
                        }
                    })
                }
            },
            editForm(){
                this.canEdit=true
                this.getAreaTree();
                this.getUserTypeList();
                this.getUserHeadShip();
                this.getKqList();
                if(this.formData.vc_djmark){
                    this.getUserClass()
                }
            },
            cancel(){
                this.$emit('close')
            },
            forceUpdate(){
                this.$forceUpdate()
            },
            vc_djmarkChange(){
                this.i_classidList=[]
                this.formData.i_classid=null
                this.formData.vc_classname=null
                this.getUserClass()
            },

            classidsearch(val){
                this.classid_search=val;
                this.getUserClass();
            },
            async getUserClass() {
                let param = {
                    "vc_djmark":this.formData.vc_djmark,
                    "vc_search":this.classid_search
                };
                let res = await API.getUserClass(param);
                if (res.code == 1) {
                    this.i_classidList=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getKqList() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getKqList(param);
                if (res.code == 1) {
                    this.vc_djmarkList=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            i_isuserChange(val){
                this.$set( this.formData,'i_isuser',val)
                // this.formData.vc_login=this.formData.vc_name
                this.vc_loginChange(this.formData.vc_name)
                // this.$forceUpdate()
            },
            vc_loginChange(val){
                console.log(val,'val')
                this.$set( this.formData,'vc_login',val)

                if(this.formData.vc_login!=''){
                    this.validateLoginName()
                }
            },
            async validateLoginName() {
                let param = {
                    vc_login:this.formData.vc_login
                };
                let res = await API.validateLoginName(param);
                if (res.code == 1) {
                    this.vc_loginCheck=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            headshipsearch(val){
                this.headship_search=val;
                this.getUserHeadShip();
            },
            async getUserHeadShip(){
                let param={
                    vc_search:this.headship_search,
                    vc_type:'hr_headship',
                };
                let res=await API.getUserHeadShip(param);
                if ( res.code == 1 ){
                    this.i_headshipList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            typesearch(val){
                this.type_search=val;
                this.getUserTypeList();
            },
            async getUserTypeList(){
                let param={
                    vc_search:this.type_search,
                };
                let res=await API.getUserTypeList(param);
                if ( res.code == 1 ){
                    this.i_rytypeList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getAreaTree(i_id=0){
                let param = {
                    i_pid:i_id,
                    isuse:1,
                };
                let res = await API.getAreaTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        if (i_id==0){
                            this.gjList=   res.data
                        }
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getUserDetail(){
                let param = {
                    i_id:this.data.val.i_userid,
                };
                let res = await API.getUserDetail(param);
                if (res.code == 1) {
                    this.formData=res.data
                    this.vc_loginCheck=true
                    if(this.formData.i_isuser==1){
                        this.OAcanEdit=false
                    }else{
                        this.OAcanEdit=true
                    }

                    // console.log(this.formData,'this.formData')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async addUser(){
                this.disabled=true;
                let param = this.formData;
                let res = await API.addUser(param);
                if (res.code == 1) {
                    this.$message.success(res.message)
                    this.$emit('close','save')
                    this.disabled=false;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async editUser(){
                this.disabled=true;
                let param = this.formData;
                let res = await API.editUser(param);
                if (res.code == 1) {
                    this.$message.success(res.message)
                    this.$emit('close','save')
                    this.disabled=false;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async uploadFile(e) {
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];

                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "hr",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "hr",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("userid"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        this.formData.vc_filepath=res.data[0].vc_path
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }

            },
        },
    }
</script>

<style lang="scss" scoped>
    .dib{
        display: inline-block;
    }
    .center{
        text-align: center;
    }
    .flex{
        display: flex;
    }
    .flex1{
        flex: 1;
    }
    .margin_b15{
        margin-bottom: 15px;
    }
    .margin_l8{
        margin-left: 8px;
    }
    .margin_b8{
        margin-bottom: 8px;
    }
    /deep/.el-form-item--mini.el-form-item,.el-form-item--small.el-form-item{
        margin-bottom:14px !important;
    }
    .grxx{
        width: calc(100% - 7px);

        .cardInfo{
            width: calc(100% - 230px);
        }
    }
    .card{
        position: relative;
        width: 100%;
        height: 100%;
        border: 1px solid #DCDFE6;
        padding: 14px 5px 5px 0px;
        .cardTitle{
            color: #a40d0d;
            position: absolute;
            top: -12px;
            left: 10px;
            display: inline-block;
            z-index: 2;
            background-color: white;
            padding:0 5px ;

        }

        .cardImg{
            width: 230px;
            overflow: hidden;
        }

        .uploadDiv{
            width: 100%;
            height: 100%;
            text-align: center;
            vertical-align: middle;
            display: flex;
            align-items: center;
            justify-content: center;

        }
        .upload-input {
            position: absolute;
            opacity: 0;
            width: 100%;
            height: 100%;
        }
    }
    .gzxx{
        width: calc(50% - 107px);
    }
    .lxfs{
        width: calc(50% + 123px);
    }
</style>